"use strict";

define('uikit/modules/input.counter',['backbone', 'marionette', 'underscore', '../mixins/component.mixin', '../elements/input', '../elements/button', '../channel', '../templates'], function (Backbone, Mn, _, ComponentMixin, InputView, ButtonView, channel, Templates) {
  var NumberInput = InputView.extend({
    options: _.extend({}, InputView.prototype.options, {
      inputType: 'number',
      allowNegative: false
    }),
    update: _.extend({}, InputView.prototype.update, {
      allowNegative: false
    }),
    events: _.extend({}, InputView.prototype.events, {
      'blur input': function blur_input(ev) {
        this.ui.input.val(this.ui.input.val());
      }
    }),
    updateAttributes: function updateAttributes() {
      InputView.prototype.updateAttributes.apply(this, arguments);
      if (this.getBoolOption('allowNegative')) {
        this.ui.input.prop('min', -Infinity);
      } else {
        this.ui.input.prop('min', 0);
      }
    },
    setMaxProperty: function setMaxProperty(max) {
      this.ui.input.prop('max', max);
    }
  });
  var IncrementButton = ButtonView.extend({
    className: 'ui increment button',
    options: _.extend({}, ButtonView.prototype.options, {
      icon: 'angle up',
      basic: true
    })
  });
  var DecrementButton = ButtonView.extend({
    className: 'ui decrement button',
    options: _.extend({}, ButtonView.prototype.options, {
      icon: 'angle down',
      basic: true
    })
  });
  var Counter = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui counter',
    template: Templates.UIKit['input.counter'],
    options: {
      disabled: false,
      fluid: false,
      readonly: false,
      model: null,
      allowNegative: false,
      value: null
    },
    update: {
      disabled: false,
      fluid: false,
      readonly: false,
      allowNegative: false
    },
    internalViews: {
      input: NumberInput,
      increment: IncrementButton,
      decrement: DecrementButton
    },
    internalViewBindings: {
      input: {
        allowNegative: 'allowNegative',
        disabled: 'disabled',
        fluid: 'fluid',
        readonly: 'readonly',
        value: 'value'
      }
    },
    onFirstRender: function onFirstRender() {
      this._updateCounterControls();
      this._counterSetupListeners();
    },
    _counterSetupListeners: function _counterSetupListeners() {
      var input = this.input;
      this.listenTo(this.increment, 'press', function () {
        var value = parseInt(input.value);
        input.value = _.isNaN(value) ? 1 : ++value;
      }).listenTo(this.decrement, 'press', function () {
        var value = parseInt(input.value);
        if (_.isNaN(value)) {
          value = 0;
        } else if (!this.allowNegative && value == 0) {
          value = 0;
        } else {
          --value;
        }
        input.value = value;
      });
    },
    _updateCounterControls: function _updateCounterControls() {
      var disabled = this.getBoolOption('disabled'),
        readonly = this.getBoolOption('readonly');
      this.increment.disabled = disabled || readonly;
      this.decrement.disabled = disabled || readonly;
    },
    onChangeDisabled: function onChangeDisabled() {
      this._updateCounterControls();
    },
    onChangeReadonly: function onChangeReadonly() {
      this._updateCounterControls();
    },
    updateAttributes: function updateAttributes() {
      this.addClass('fluid', this.getBoolOption('fluid'));
    }
  });
  channel.reply('input-counter', function () {
    return Counter;
  });
  return Counter;
});

